import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModel } from 'src/app/core/models/base.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { DefaultImageService } from 'src/app/core/services/default-image.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.scss']
})
export abstract class BaseModalComponent implements OnInit, OnDestroy {
  
  protected modalEdited: boolean = false; 
  protected newModel: boolean = false; 
  protected submitted: boolean = false;
  protected disableEditing: boolean = false;
  protected defaultImageService: DefaultImageService = new DefaultImageService();

  protected  stringPattern = { '%': GlobalComponent.stringPattern };

  constructor(
    protected myFileApiService: MyfileApiService,
    protected authMyFileService: AuthMyfileService,
    protected modalRef: NgbActiveModal,
    protected toasterNotificationService: ToasterNotificationService,
    protected sanitizer: DomSanitizer,
  ) { }

  @Input() public model: BaseModel = new BaseModel;
  @Input() public activeTab: number = 1;

  close() {
    if (this.modalEdited) {
      this.confirmExit();
    } else {
      this.modalRef.close();
    }
  }

  profilePhotoPNGTransform(profilePhoto: any) {
    if (profilePhoto && profilePhoto.listPhoto) {
      return profilePhoto.listPhoto;
    }
    if (profilePhoto !== undefined) {
      profilePhoto.listPhoto = this.defaultImageService.getDefaultUserImage(profilePhoto.fullName);
      return profilePhoto.listPhoto;
    }
    return this.defaultImageService.getDefaultUserImage();
  }

  confirmExit() {
    Swal.fire({
      title: $localize`:@@SWAL_UnsavedChanges:You have unsaved changes!`,
      text: $localize`:@@:Are you sure you want to leave?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@SWAL_Yes_Discard:Yes, discard changes`,
      cancelButtonText: $localize`:@@SWAL_No_Save:No, I want to save`
    }).then(result => {
      if ( result && result.isConfirmed) {
        this.modalRef.close();
      }
    });
  }

  onSave(): void {
    this.submitted = true;
    if(this.validate()){
      this.modalEdited = false;
      if(this.newModel){
        this.onCreate(); 
      }else{
        this.onUpdate();
      }
    }
  }

  onNewModalEntityFileIdsAdded(model: any, result: any) {
    result.forEach((element:string) => {
      model.fileUpload.fileIdsToAdd.push(element);
    });
  }

  abstract ngOnInit(): void;

  abstract ngOnDestroy(): void;

  abstract validate(): boolean;
  
  abstract onUpdate(): void;

  abstract onCreate(): void;

}
